import React, { ChangeEvent, memo, useCallback, useRef } from 'react'
import * as styles from './styles.module.scss'
import Svg from '../../svg/svg'
import { canvasSize, dataURLtoFile } from '../helpers'

const UploadItemImageButton = ({
   onImageUpload,
   isDisabled,
}: UploadItemImageButtonProps) => {
   const ref = useRef<HTMLInputElement | null>(null)
   const canvasRef = useRef<HTMLCanvasElement | null>(null)

   const onClick = useCallback(() => ref?.current?.click(), [ref])

   const handleFileChange = useCallback(
      (e: ProgressEvent<FileReader>, file: Blob) => {
         // @ts-ignore
         const imageUrl = e.currentTarget.result as string // base64
         const mimeType: string = RegExp(
            new RegExp('data:' + '(.*)' + ';base64')
         ).exec(imageUrl)[1]
         const thumbName = 'thumb_' + file['name']

         const ctx = canvasRef?.current?.getContext('2d')
         function draw(ctx) {
            ctx.clearRect(0, 0, ctx.width, ctx.height)
            requestAnimationFrame(() => draw(ctx))
         }
         requestAnimationFrame(() => draw(ctx))

         const url = URL.createObjectURL(file)
         const img = new Image()

         img.src = url
         img.height = canvasSize
         img.width = canvasSize
         img.onload = function () {
            ctx.drawImage(img, 0, 0, canvasSize, canvasSize)
            const base64Full = ctx.canvas.toDataURL()

            const newFile = dataURLtoFile(base64Full, thumbName)
            onImageUpload(file, newFile, mimeType, imageUrl)
         }
      },
      [canvasRef, onImageUpload]
   )

   const onChange = useCallback(
      (event: ChangeEvent<HTMLInputElement>) => {
         const file = event?.target?.files[0] ?? null
         if (file) {
            const fileData = new FileReader()
            fileData.readAsDataURL(file)
            fileData.onloadend = (e: ProgressEvent<FileReader>) =>
               handleFileChange(e, file)
         }
      },
      [handleFileChange]
   )

   return (
      <>
         <canvas
            ref={canvasRef}
            width={canvasSize}
            height={canvasSize}
            className={styles.hidden}
         />
         <button type="button" className={styles.button} onClick={onClick}>
            <input
               type="file"
               accept=".jpg, .png"
               ref={ref}
               onChange={onChange}
               disabled={isDisabled}
            />
            <Svg id="plus" width="40" height="40" />
         </button>
      </>
   )
}

export default memo(UploadItemImageButton)
